var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vs-row",
        [
          _c(
            "vs-col",
            {
              staticClass: "pt-2 border-top",
              attrs: { "vs-offset": "1", "vs-lg": "11", "vs-type": "flex" }
            },
            [
              _c(
                "vs-chip",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Próxima facturación",
                      expression: "'Próxima facturación'"
                    }
                  ],
                  staticClass: "mr-4"
                },
                [
                  _c("vs-avatar", { attrs: { icon: "date_range" } }),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("dateFormat")(
                          "2022" + "-" + "10" + "-" + _vm.file.configuracion.day
                        )
                      ) +
                      " "
                  )
                ],
                1
              ),
              _c(
                "vs-chip",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Estado de facturación",
                      expression: "'Estado de facturación'"
                    }
                  ],
                  staticClass: "mr-3"
                },
                [
                  _c("vs-avatar", {
                    attrs: {
                      icon: _vm.file.estado ? "check" : "do_not_disturb",
                      color: _vm.file.estado ? "#43C3B9" : "#DB1D2A"
                    }
                  }),
                  _vm._v(
                    " " + _vm._s(_vm.file.estado ? "Activo" : "Inactivo") + " "
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }